import { Alarms } from "@services/monitoring/types";

export const getRealtimeAlarms = (alarms?: Alarms) => {
  const dataAlarms = alarms
    ? (alarms.warningPageAlerts?.length ?? 0) + (alarms.pageAlerts?.length ?? 0)
    : 0;
  return dataAlarms;
};
export const useAlarmsFormatter = () => {
  return { getRealtimeAlarms };
};
